var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelevisionRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.43172H7.13885C6.58656 9.43172 6.13885 8.98401 6.13885 8.43172V4C6.13885 3.44772 6.58656 3 7.13885 3H16.8612C17.4134 3 17.8612 3.44772 17.8612 4V8.43172C17.8612 8.98401 17.4134 9.43172 16.8611 9.43172H12ZM12 9.43172V11.8689M12 11.8689H10.3412M12 11.8689H13.5851M12 11.8689V12.9123M12 12.9123H8.3506M12 12.9123H15.6494M8.3506 12.9123H3C2.44772 12.9123 2 13.36 2 13.9123V18.1727C2 18.725 2.44772 19.1727 3 19.1727H3.40078M8.3506 12.9123V16.0425M8.3506 19.1727H15.6494M8.3506 19.1727V16.0425M8.3506 19.1727H3.40078M15.6494 12.9123H21C21.5523 12.9123 22 13.36 22 13.9123V18.1727C22 18.725 21.5523 19.1727 21 19.1727H20.5255M15.6494 12.9123V16.0425M15.6494 19.1727V16.0425M15.6494 19.1727H20.5255M8.3506 16.0425H15.6494M3.40078 19.1727V21M20.5255 19.1727V21",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevisionRoom);
export default __webpack_public_path__ + "static/media/television_room.a73f11685a9915195850a7db53f0746b.svg";
export { ForwardRef as ReactComponent };